import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-8 md:py-10 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-6 text-center">
          探索分类
        </h2>
        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
              className="px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700 border border-background-200/70 hover:border-primary-200"
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}